import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d1b254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "play icon i-tool-play" }, null, -1))
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "tag" }
const _hoisted_5 = {
  key: 0,
  class: "nbs"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-guankancishu" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-aixin" }, null, -1))

import * as filters from '@/views/filters';


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: any
}




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "short-item",
    style: _normalizeStyle(_unref(filters).bg(__props.item.thumb)),
    to: `/shorts/index.html?id=${__props.item.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.item.title), 1),
        _createElementVNode("div", _hoisted_4, "#" + _toDisplayString(__props.item.tag) + "#", 1),
        (__props.item.hits)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", null, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(__props.item.hits), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_7,
                _createTextVNode(_toDisplayString(__props.item.favs), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style", "to"]))
}
}

})